import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";

export const MedicationsTable = ({
  data,
  activeSection,
  handleEditRow = () => { },
  handleDeleteRow = () => { },
}) => {
  if (!data || data.length === 0) return null;

  return (
    <>
      {data.length > 0 && (
        <Grid item xs={12}>
          <StyledTableContainer
            component={Paper}
          // sx={{
          //   margin: "10px 5px",
          //   border: "1px solid #21cdc0",
          //   overflowX: "auto",
          //   width: "100%",
          // }}
          >
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>Medicine Name</StyledTableCellHistory>
                  <StyledTableCellHistory>Timing</StyledTableCellHistory>
                  <StyledTableCellHistory>Frequency</StyledTableCellHistory>
                  <StyledTableCellHistory>Dosage</StyledTableCellHistory>
                  <StyledTableCellHistory>
                    Additional Instructions
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>Duration</StyledTableCellHistory>
                  {/* <StyledTableCellHistory>Instruction</StyledTableCellHistory> */}
                  <StyledTableCellHistory>Reasons</StyledTableCellHistory>
                  <StyledTableCellHistory>Route</StyledTableCellHistory>
                  <StyledTableCellHistory>Notes</StyledTableCellHistory>

                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row?.term}
                      {row?.source === "voice" && !row.id && (
                        <Tooltip title="Machine-interpreted text — please verify before confirming">
                          <span className="missing-id-warning">⚠️</span>
                        </Tooltip>
                      )}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {[row?.time, row?.when].filter(Boolean).join(" ") || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {/* {row?.frequency} */}
                      {row?.frequency || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.dosage || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {typeof row?.additionalInstructions === "string"
                        ? row?.additionalInstructions || "-"
                        : row?.additionalInstructions
                          ?.map((option) => option.term)
                          .join(", ") || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.duration
                        ? `${row?.duration} ${row?.durationType}`
                        : "-"}
                    </StyledTableCellHistory>
                    {/* <StyledTableCellHistory>
                      {row?.instructions.length > 0 ? row.instructions : "-"}
                    </StyledTableCellHistory> */}
                    <StyledTableCellHistory>
                      {row?.reasons.length > 0 ? row.reasons.join(", ") : "-"}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {row.selectedAdministration
                        ? row.selectedAdministration.label
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.medicineNote.length > 0 ? row.medicineNote : "-"}
                    </StyledTableCellHistory>
                    {activeSection && (
                      <StyledTableCellHistory sx={{ display: "flex" }}>
                        <OutlinedIconFab
                          onClick={() => handleEditRow(rowIndex)}
                          sx={{ marginRight: 1 }}
                        >
                          <Icon name="editInTable" size={32} />
                        </OutlinedIconFab>

                        <OutlinedIconFab
                          onClick={() => handleDeleteRow(rowIndex)}
                        >
                          <Icon name="deleteInTable" size={32} />
                        </OutlinedIconFab>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
